const ua = navigator.userAgent.toLowerCase()

function compareVersion(version1, version2) {
    const arr1 = version1.split('.')
    const arr2 = version2.split('.')
    const length1 = arr1.length
    const length2 = arr2.length
    const minlength = Math.min(length1, length2)
    let i = 0
    for (i; i < minlength; i++) {
        let a = parseInt(arr1[i])
        let b = parseInt(arr2[i])
        if (a > b) {
            return 1
        } else if (a < b) {
            return -1
        }
    }
    if (length1 > length2) {
        for (let j = i; j < length1; j++) {
            if (parseInt(arr1[j]) != 0) {
                return 1
            }
        }
        return 0
    } else if (length1 < length2) {
        for (let j = i; j < length2; j++) {
            if (parseInt(arr2[j]) != 0) {
                return -1
            }
        }
        return 0
    }
    return 0
}
function getParamsFromJrUA(param = '', userAgent) {
    const reg = new RegExp(`(^|&)${param}=([^&]*)(&|$)`)
    const r = userAgent.match(reg)
    if (r != null && Array.isArray(r)) {
        return r[2]
    }
    return ''
}
// https://cf.jd.com/pages/viewpage.action?pageId=181277416
const isInJdJrApp = () => /jdjr-app/.test(ua)

// const loadJS = jsUrl => new Promise((resolve, reject) => {
//     try {
//         const script = document.createElement('script')
//         script.type = 'text/javascript'
//         script.src = jsUrl
//         script.onload = () => {
//             resolve(true)
//         }
//         document.getElementsByTagName('head')[0].appendChild(script)
//     } catch (error) {
//         reject(error)
//     }
// })
export function loadAAR2() {
    // return loadJS('//jrsecstatic.jdpay.com/jr-sec-dev-static/aar2.min.js')
    return new Promise((resolve, reject) => {
        try {
            if (window.AAR2) {
                resolve(true)
            }else{
                const script = document.createElement('script')
                script.type = 'text/javascript'
                // script.src = '//jrsecstatic.jdpay.com/jr-sec-dev-static/aar2.min.js'
                script.src = '//jrsecstatic.jdpay.com/jr-sec-dev-static/aar2-2.1.0.min.js'
                script.onload = () => {
                    resolve(true)
                }
                document.getElementsByTagName('head')[0].appendChild(script)
            }
        } catch (error) {
            reject(error)
        }
    })
}
export function initAAR2(alg) {
    return new Promise((resolve, reject) => {
        if(window.jr_aar2_init){
            resolve(true)
        }else{
            window.AAR2.init({
                alg,
                callback(success, error) {
                    console.log('success:', success, 'error:', error.errorNo)
                    if (success) {
                        window.jr_aar2_init = true;
                        resolve(success)
                    } else {
                        reject(error)
                    }
                }
            })
        }
    })
}
export async function aar2sign(signData) {
    return new Promise((resolve, reject) => {
        try {
            const aar = new window.AAR2() // 1，new对象
            const nonce = aar.nonce() // 2，产生nonce
            // 3，对signData签名，第一个参数为要保护防篡改的报文内容类型需要为string，第二个参数用nonce固定
            const signature = aar.sign(signData, nonce)
            resolve({ nonce, signData, signature })
        } catch (error) {
            reject(error)
        }
    })
}

export async function aar2signWithInit(signData, alg) {
    return new Promise((resolve, reject) => {
        loadAAR2().then(() => {
            initAAR2(alg).then(() => {
                aar2sign(signData).then(res => {
                    // console.log('~~~~~~~~~~~~~~~~~~~~', res)
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            }).catch(error => {
                reject(error)
            })
        }).catch(error => {
            reject(error)
        })
    })
}
export async function aar2signWithoutInit(signData) {
    return new Promise((resolve, reject) => {
        loadAAR2().then(() => {
            aar2sign(signData).then(res => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        }).catch(error => {
            reject(error)
        })
    })
}
export async function sign (signData, needInit=true, refresh=false, alg = 'sm3') {
    if (isInJdJrApp()) {
        const version = getParamsFromJrUA('clientversion', ua)
        if (compareVersion(version, '6.6.10') >= 0 && window.JrBridge && compareVersion(window.JrBridge._version, '2.2.0') >= 0) {
            return new Promise((resolve, reject) => {
                try {
                    // 获取 AAR2 签名
                    const data = {
                        type: '100',
                        subType: refresh ? 'refresh' : '',
                        signData
                    }
                    console.log('------------------jsbridge-------------------')
                    window.JrBridge.callNative(data, res => {
                        // console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~', res)
                        if (res && res.errorCode == '00000') {
                            resolve(res)
                        } else {
                            console.log('------------------aar2js-------------------')
                            resolve(needInit ? aar2signWithInit(signData, alg) : aar2signWithoutInit(signData)) 
                        }
                    })
                } catch (error) {
                    reject(error)
                }
            })
        } else {
            console.log('------------------aar2js-------------------')
            return needInit ? aar2signWithInit(signData, alg) : aar2signWithoutInit(signData);
        }
    } else {
        console.log('------------------aar2js-------------------')
        return needInit ? aar2signWithInit(signData, alg) : aar2signWithoutInit(signData);
    }
}